import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export default function PublicBioPage() {
  const { slug } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  useEffect(() => {
    axios.get(`${API_BASE}/public/bio/${slug}`)
      .then(res => { setProfile(res.data); setLoading(false); })
      .catch(() => { setError('Page not found'); setLoading(false); });
  }, [slug]);

  const handleClick = async (link) => {
    // Track click in background
    try { await axios.post(`${API_BASE}/public/bio/${slug}/links/${link.id}/click`); } catch {}
    window.open(link.url, '_blank', 'noopener,noreferrer');
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f8fafc' }}>
      <div style={{ color: '#94a3b8', fontSize: '0.9rem' }}>Loading…</div>
    </div>
  );

  if (error || !profile) return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f8fafc', textAlign: 'center', padding: '2rem' }}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>😕</div>
      <div style={{ fontWeight: 700, fontSize: '1.1rem', color: '#1e293b', marginBottom: '0.4rem' }}>Page not found</div>
      <div style={{ color: '#64748b', fontSize: '0.85rem' }}>The bio page @{slug} doesn't exist or is private.</div>
    </div>
  );

  const themeColor = profile.themeColor || '#6366f1';
  const activeLinks = (profile.links || []).filter(l => l.isActive !== false);

  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9', display: 'flex', justifyContent: 'center', padding: '0 0 3rem' }}>
      <div style={{ width: '100%', maxWidth: 480 }}>
        {/* Hero */}
        <div style={{ background: themeColor, padding: '3rem 2rem 2.5rem', textAlign: 'center',
                      borderRadius: '0 0 32px 32px', marginBottom: '1.5rem' }}>
          <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'rgba(255,255,255,0.2)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '2.5rem', margin: '0 auto 1rem', backdropFilter: 'blur(4px)' }}>
            {profile.avatarEmoji || '🎬'}
          </div>
          <h1 style={{ color: 'white', margin: '0 0 0.5rem', fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: '1.5rem', letterSpacing: '-0.02em' }}>
            {profile.displayName || `@${profile.slug}`}
          </h1>
          {profile.bio && (
            <p style={{ color: 'rgba(255,255,255,0.85)', margin: 0, fontSize: '0.88rem', lineHeight: 1.55, maxWidth: 340, marginLeft: 'auto', marginRight: 'auto' }}>
              {profile.bio}
            </p>
          )}
        </div>

        {/* Links */}
        <div style={{ padding: '0 1.25rem' }}>
          {activeLinks.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#94a3b8', padding: '3rem 0', fontSize: '0.88rem' }}>
              No links added yet
            </div>
          ) : (
            activeLinks.map(link => (
              <button key={link.id} onClick={() => handleClick(link)}
                style={{ display: 'flex', alignItems: 'center', gap: '0.85rem',
                         width: '100%', padding: '1rem 1.25rem',
                         borderRadius: 16, background: 'white', border: 'none',
                         marginBottom: '0.75rem', textAlign: 'left', cursor: 'pointer',
                         boxShadow: '0 2px 8px rgba(0,0,0,0.07)', transition: 'transform 0.1s, box-shadow 0.1s' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.12)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.07)'; }}>
                <div style={{ width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                              background: themeColor + '15',
                              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem' }}>
                  {link.icon || '🔗'}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: '0.95rem', color: '#1e293b' }}>{link.title}</div>
                  {link.category && (
                    <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: '0.1rem' }}>{link.category}</div>
                  )}
                </div>
                <div style={{ width: 28, height: 28, borderRadius: '50%', background: themeColor,
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              color: 'white', fontSize: '0.8rem', fontWeight: 700, flexShrink: 0 }}>
                  →
                </div>
              </button>
            ))
          )}
        </div>

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '2.5rem', color: '#94a3b8', fontSize: '0.75rem' }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem' }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#4dba7a', display: 'inline-block' }} />
            Made with CreatorKhata
          </span>
        </div>
      </div>
    </div>
  );
}
